import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchCrawlHealthReport, type CrawlHealthParams, type CrawlHealthRow } from '../services/rpc/crawl';

const DEFAULT_PARAMS: CrawlHealthParams = {
  days: 7,
  limit: 50,
};

export const crawlHealthQueryKey = (params: CrawlHealthParams) => ['crawl-health-report', params] as const;

export function useCrawlHealthReport(params: CrawlHealthParams = DEFAULT_PARAMS): UseQueryResult<CrawlHealthRow[]> {
  return useQuery<CrawlHealthRow[]>({
    queryKey: crawlHealthQueryKey(params),
    queryFn: () => fetchCrawlHealthReport(params),
  });
}
